import { cookie } from '@otto-ec/global-resources/cookie'

export function isApp(): boolean {
  /*                                                                     */
  return cookie.get('app') === 'true'
}
